import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CommonUtil } from "app/utils/common.util";
import { UrlUtil } from "app/utils/url.util";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class ContractTemplateService {
  constructor(
    private http: HttpClient,
    private urlUtil: UrlUtil,
    private commonUtil: CommonUtil,
    private _translateService: TranslateService
  ) {}

  public getContractTemplateList() {
    return this.http
      .get(this.urlUtil.getUrl("contractTemplate", "getAll").replace("$ORGANISATION_ID", this.commonUtil.getUserDetail("organisationId")))
      .pipe(
        map((response: any) => {
          const { status, data, message } = response;
          if (status && data?.length) {
            return data;
          } else {
            return [];
          }
        }),
        catchError((e) => {
          console.log("getContractTemplateList error =>", e);
          return of([]);
        })
      );
  }
  public getContractTemplateListByOrganisation(id) {
    return this.http.get(this.urlUtil.getUrl("contractTemplate", "getAll").replace("$ORGANISATION_ID", id)).pipe(
      map((response: any) => {
        const { status, data, message } = response;
        if (status && data?.length) {
          return data;
        } else {
          return [];
        }
      }),
      catchError((e) => {
        console.log("getContractTemplateList error =>", e);
        return of([]);
      })
    );
  }

  public getContractTemplateById(id: string = null) {
    return this.http.get(this.urlUtil.getUrl("contractTemplate", "getById").replace("$ID", id)).pipe(
      map((response: any) => {
        if (response.status) {
          return response.data;
        } else {
          return null;
        }
      }),
      catchError((e) => {
        console.log("getContractTemplateById error =>", e);
        return of(null);
      })
    );
  }

  public addContractTemplate(data) {
    return this.http.post(this.urlUtil.getUrl("contractTemplate", "add"), data).pipe(
      map((response: any) => {
        const { status, jsonData, errorMessage } = response;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataAddSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataAdd")
          };
        }
      }),
      catchError((e) => {
        console.log("add ContractTemplate error =>", e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataAdd")
        });
      })
    );
  }

  public updateContractTemplate(data) {
    return this.http.put(this.urlUtil.getUrl("contractTemplate", "update").replace("$ID", data.id), data).pipe(
      map((response: any) => {
        const { status, jsonData, errorMessage } = response;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataUpdateSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataUpdate")
          };
        }
      }),
      catchError((e) => {
        console.log("update ContractTemplate error =>", e);
        return of({
          status: false,
          data: this._translateService.instant("FailDataUpdate")
        });
      })
    );
  }

  public deleteContractTemplate(ids: any) {
    return this.http.delete(this.urlUtil.getUrl("contractTemplate", "delete"), { body: ids }).pipe(
      map((response: any) => {
        const { status, jsonData, errorMessage, data } = response;
        if (status && ids.length === data.deletedId?.length) {
          return {
            status: status,
            message: this._translateService.instant("DataDeleteSuccess"),
            data: null
          };
        }
        return {
          status: false,
          message: errorMessage || jsonData || this._translateService.instant("FailDataDelete"),
          data: null
        };
      }),
      catchError((e) => {
        console.log("delete ContractTemplate error =>", e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataDelete")
        });
      })
    );
  }
}
